"use client";
import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:,.<>?";

export default function ScrambleText({
  children,
  className,
  onComplete,
}: {
  children: string;
  className?: string;
  onComplete?: () => void;
}) {
  const ref = useRef<HTMLHeadingElement>(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [text, setText] = useState(children);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isInView) return;

    let iteration = 0;
    clearInterval(intervalRef.current!);

    intervalRef.current = setInterval(() => {
      setText(
        children
          .split("")
          .map((_, index) =>
            index < iteration
              ? children[index]
              : CHARS[Math.floor(Math.random() * CHARS.length)]
          )
          .join("")
      );

      if (iteration >= children.length) {
        clearInterval(intervalRef.current!);
        onComplete?.(); // 👈 THIS IS KEY
      }

      iteration += 0.5;
    }, 30);
  }, [isInView, children, onComplete]);

  return (
    <h2
      ref={ref}
      className={className}
    >
      {text}
    </h2>
  );
}
